export class ObjectUtil {

	// ------------------------------------------------------------------------ parseNode
	// replace all placeholders from json data
	/*
		{server: "http:/server.com/",
			content: {
				url: "{server}api",		//will replaces to: "http:/server.com/api"
			}
		}
	*/
	static replaceNodes(json){
		let t = typeof json
		let str = t === 'object'? JSON.stringify(json) : t === 'string'? json : null
		if (!str) return null

		let i0, i1, s, f0, f1, r
		i0 = str.indexOf(':"{', 0)
		while(i0 >= 0){
			i1 = str.indexOf('}', i0+3)
			if (i1){
				s = str.substring(i0+3, i1)
				f0 = str.indexOf('"' + s + '":')
				if (f0){
					f0 += s.length + 4
					f1 = str.indexOf('"', f0)
					r = str.substring(f0, f1)
					str = str.replace(new RegExp(':"{'+s+'}', 'g'), ':"'+r)
				}
			}
			i0 = str.indexOf(':"{', i0+3)
		}

		return JSON.parse(str)
	}

	/*
	get recursiv node item from given array or dot-notated string
	e.g. getNode('a.b', {a:{b:1}}) -> 1
	https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
	*/
	static getNode(source, data, delim='.'){
		if (typeof(source) === 'string') source = source.split(delim);
		if (!Array.isArray(source)) return null;
		if (source.length === 1) return data[source[0]]

		var dat = data;
		source.forEach(p => {
			dat = dat && dat[p] !== undefined? dat[p] : null;
		})
		return dat;
	}


	// setNode(json, 'data.element.node.value', 123);
	static setNode(source, path, data, delim='.'){
		let p = path.split(delim);
		let l = p.length - 1;
		let s = source;

		p.forEach((n, i) => {
			if (i === l) s[n] = data;
			else if (!s[n]) s[n] = {};	//create node if not exist
			s = s[n];
		})
	}


	// ------------------------------------------------------------------------ append
	// merge object attributes
	static append(oObj, aObj, overwrite=true, addNew=true){
		if (!oObj || !aObj) return
		
		for (let e in aObj){
			if (typeof aObj[e] === 'object'){
				if (oObj[e] === undefined){
					if (addNew) oObj[e] = aObj[e];
				}else{
					this.append(oObj[e], aObj[e], overwrite, addNew);
				}
			}else if (oObj[e] === undefined){
				if (addNew) oObj[e] = aObj[e];
			}else if (overwrite){
				oObj[e] = aObj[e];
			}
		}
		return oObj;
	}

}